/**
 * The host the links this app sends out point at.
 *
 * Every return URL (Stripe, an email sender's validation, a sign-up's
 * verification mail, Gmail/Outlook, referral and API key links) is built
 * from the tenant's recorded domain. For Magileads' own tenant that domain
 * is `application.magileads.io` (or the legacy `.net`), and the deployment
 * can move it with `RUNTIME_APP_URL` (`window._env_.APP_URL`) — the address
 * this app is actually served on — instead of a change in code.
 *
 * Only Magileads' own hosts are replaced: a white label keeps its domain.
 * Without `RUNTIME_APP_URL` nothing changes.
 */
const MAGILEADS_HOSTS = ["application.magileads.io", "application.magileads.net"];

function configuredHost() {
  const raw = (window._env_?.APP_URL || "").trim();
  if (!raw) return null;
  try {
    return new URL(/^https?:\/\//i.test(raw) ? raw : `https://${raw}`).host;
  } catch {
    return null;
  }
}

/** A recorded domain, as a link should use it. */
export function publicHost(domain) {
  const configured = configuredHost();
  if (configured && domain && MAGILEADS_HOSTS.includes(domain.trim().toLowerCase())) {
    return configured;
  }
  return domain;
}

/** The current tenant's host for a link: its newest domain, through `publicHost`. */
export function appHost(reseller) {
  return publicHost(reseller?.domain_saas3 || reseller?.domain_saas2);
}
